import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { getAreas, deleteArea, updateAreasPagination } from '../../store/actions/area/area_action';
import { makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import TablePagination from '../ui_components/table_pagination';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';
import ActionsComponent from '../ui_components/actions_component';

const useStyles = makeStyles((theme) => ({
	paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    },
    table: {
        minWidth: 500
    }
}));

const AreasTable = ({ areas: { collection, totalCount, page, rowsPerPage, filters } }) => {
    const { paper, table, tableRow } = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!collection.length) {
            dispatch(getAreas({ page, rowsPerPage, filters }));
        }
    }, []);

    const handleClick = (uuid) => {
        history.push(`${REACT_ROUTES.AREA}/${uuid}`);
    }

    const handleDeleteArea = (uuid) => {
        dispatch(deleteArea(uuid))
            .then(() => dispatch(getAreas({ page, rowsPerPage, filters })));
    }

    return (
        <Paper className={paper}>
            <Table aria-label="table" className={table}>
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Naziv oblasti</TableCell>
                        <TableCell align="right">Akcije</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {collection.map(({ uuid, name, deletable }, index) =>
                        <TableRow hover key={index} className={tableRow}>
                            <TableCell align="center">{ name }</TableCell>
                            <TableCell align="right">
                                <ActionsComponent
                                    handleEdit={() => handleClick(uuid)}
                                    handleDelete={() => handleDeleteArea(uuid)}
                                    deletable={deletable}
                                    label="oblast"
                                />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                <TablePagination
                    page={page}
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    filters={filters}
                    updatePagination={updateAreasPagination}
                 />
            </Table>
        </Paper>
    )
}

AreasTable.propTypes = {
    areas: PropTypes.object
}

const mapStateToProps = (state) => ({
    areas: state.areas
});

export default connect(mapStateToProps)(AreasTable);
